export class StructureNode {

    stationGroupId: number;
    stationSetId: number;
    name: string;

    constructor(name: string, stationGroupId: number, stationSetId: number) {
        this.name = name;
        this.stationGroupId = stationGroupId;
        this.stationSetId = stationSetId;
    }
}